var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_3193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 0C7.49687 0 0.333496 7.16337 0.333496 16C0.333496 24.8366 7.49687 31.9999 16.3335 31.9999C25.1701 31.9999 32.3335 24.8366 32.3335 16C32.3334 7.16337 25.1699 0 16.3335 0ZM12.0646 23.7352H8.55169V12.3859H12.0646V23.7352ZM10.2914 10.8996C9.14413 10.8996 8.21405 9.96191 8.21405 8.80543C8.21405 7.64882 9.14426 6.71121 10.2914 6.71121C11.4386 6.71121 12.3687 7.64882 12.3687 8.80543C12.3687 9.96198 11.4387 10.8996 10.2914 10.8996ZM25.2294 23.7352H21.7335V17.7778C21.7335 16.1438 21.1129 15.2317 19.8208 15.2317C18.4147 15.2317 17.6801 16.1816 17.6801 17.7778V23.7352H14.3108V12.3859H17.6801V13.9144C17.6801 13.9144 18.6936 12.0397 21.1001 12.0397C23.5067 12.0397 25.2295 13.5091 25.2295 16.549L25.2294 23.7352Z",
    fill: "url(#paint0_linear_3058_3193)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3058_3193",
    x1: 5.01977,
    y1: 4.68628,
    x2: 27.6472,
    y2: 27.3137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_3193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin_logo.7c28813502ce159c20a929b1a01d0e34.svg";
export { ForwardRef as ReactComponent };